import React from "react"
import Twitter from "../../images/inline-svgs/social/twitter-x-dark.svg"
import Linkedin from "../../images/inline-svgs/social/linkedin-3.svg"
import Email from "../../images/inline-svgs/social/link.svg"

type Props = {
  post: any
}

const PostSharing: React.FC<Props> = ({ post }) => {
  return (
    <div className="post__sharing">
      <div className="post__sharing-title ">Share article</div>
      <div className="post__sharing-icons pt-4">
        <button
          className="post__sharing-icon"
          onClick={() => {
            window.open(
              `https://twitter.com/share?text=${post.title}&amp;url=${window.location.href}`,
              "share-twitter",
              "width=550,height=235",
            )
            return false
          }}
        >
          <span className="icon icon--twitter">
            <Twitter />
          </span>
        </button>

        <button
          className="post__sharing-icon"
          onClick={() => {
            window.open(
              `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${post.title}&summary=${post.excerpt}`,
              "share-linkedin",
              "width=550,height=235",
            )
            return false
          }}
        >
          <span className="icon icon--linkedin">
            <Linkedin />
          </span>
        </button>

        <button
          className="post__sharing-icon post__sharing-icon--email"
          onClick={() => {
            window.location.href = `mailto:?subject=${post.title}&amp;body=Check out this site ${window.location.href}`
          }}
          title="share by email"
        >
          <span className="block icon icon--email">
            <Email style={{ padding: "2px" }} />
          </span>
        </button>
      </div>
    </div>
  )
}

export default PostSharing
